<app-dashboard-wrapper
  class="payroll mobile-bank-settings"
  title="{{
    'dashboard-payroll-settings.component.distributions'
      | localise: 'Distributions'
  }}"
  [loading]="loading"
  headerTableButton2="{{
    'dashboard-banks.component.add_bank_account_header_button'
      | localise: 'Add Bank Account'
  }}"
  headerTableButton="{{
    list.length > 0
      ? ('dashboard-payroll-settings.component.edit_distributions'
        | localise: 'Edit Distributions')
      : ''
  }}"
  (headerTableButton2Click)="openBankAccount()"
  (headerTableButtonClick)="editDistributions(editModalTmp)">
  <div class="payroll-block mobile-bank-accounts">
    @if (list.length > 0) {
      <div class="table-wrapper forms-support-dark-mode">
        <table class="payroll-block__table">
          <tr class="header-table">
            <th class="table-25-per">
              {{
                'dashboard-payroll-settings.component.account'
                  | localise: 'Account'
              }}
            </th>
            <th class="table-25-per distribution-col-mobile">
              {{
                'dashboard-payroll-settings.component.distribution'
                  | localise: 'Distribution'
              }}
            </th>
            <th class="table-25-per distribution-col-tbl">
              {{
                'dashboard-payroll-settings.component.type' | localise: 'Type'
              }}
            </th>
            <th class="table-25-per">
              {{
                'dashboard-payroll-settings.component.transaction_fee'
                  | localise: 'Transaction Fee'
              }}
            </th>
            <th class="table-25-per distribution-col-tbl">
              {{
                'dashboard-payroll-settings.component.distribution'
                  | localise: 'Distribution'
              }}
            </th>
            <th class="table-25-per distribution-col-mobile">
              {{
                'dashboard-payroll-settings.component.type' | localise: 'Type'
              }}
            </th>
          </tr>
          <tr class="standard_transfer">
            <td class="p-l-0 has-tooltip" colspan="4">
              <img src="/assets/img/icons/bank.svg" alt="" />
              <span>
                {{
                  'dashboard-payroll-settings.component.bank_accounts_standard_transfer'
                    | localise: 'Bank Accounts - Standard Transfer'
                }}
              </span>
              <img
                (mouseenter)="showTooltipStandard = true"
                (mouseleave)="showTooltipStandard = false"
                (click)="showTooltip()"
                src="/assets/img/icons/info.svg"
                alt="" />
              <div class="icon-tooltip">
                <div
                  class="block-tooltip"
                  [class.show-tooltip]="showTooltipStandard">
                  <div>
                    <div class="header-tooltip">
                      <img
                        class="m-0"
                        src="/assets/img/icons/bank-white.svg"
                        alt="" />
                      <span>
                        {{
                          'dashboard-payroll-settings.component.bank_accounts_standard_transfer'
                            | localise: 'Bank Accounts - Standard Transfer'
                        }}
                      </span>
                    </div>
                    <div>
                      {{
                        'dashboard-payroll-settings.component.accounts_used_standard_transfers'
                          | localise
                            : 'These accounts are used for standard ACH transfers. These transfers are typically posted by the next business day.'
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          @for (app of bankAccounts; track app.id) {
            <tr [ngClass]="{ limpid: !percentBankAccountsMap[app.id] }">
              <td class="crop-text-mobile">
                {{
                  app.accountNickname ? app.accountNickname : app.institution
                }}
                {{ app.accountNumber }}
              </td>
              <td class="distribution-col-mobile">
                @if (percentBankAccountsMap[app.id]) {
                  {{
                    percentBankAccountsMap[app.id]
                      | currencyJs: { withoutDecimal: true }
                  }}%
                }
                @if (!percentBankAccountsMap[app.id] && app.id > 0) {
                  0%
                }
              </td>
              <td class="capitalize-first-letter distribution-col-tbl">
                {{ app.accountType }}
              </td>
              <td>N/A</td>
              <td class="distribution-col-tbl">
                @if (percentBankAccountsMap[app.id]) {
                  {{
                    percentBankAccountsMap[app.id]
                      | currencyJs: { withoutDecimal: true }
                  }}%
                }
                @if (!percentBankAccountsMap[app.id] && app.id > 0) {
                  0%
                }
              </td>
              <td class="capitalize-first-letter distribution-col-mobile">
                {{ app.accountType }}
              </td>
            </tr>
          }
          @if (astraCards.length > 0 || ingoCards.length > 0) {
            <tr class="standard_transfer">
              <td class="p-l-0 has-tooltip" colspan="4">
                <img src="/assets/img/icons/flash.svg" alt="" />
                <span
                  >{{
                    'dashboard-payroll-settings.component.debit_cards_instant_transfer'
                      | localise: 'Debit Cards - Instant Transfer'
                  }}
                </span>
                <img
                  (mouseenter)="showTooltipInstant = true"
                  (mouseleave)="showTooltipInstant = false"
                  (click)="showHideTooltipInstant()"
                  src="/assets/img/icons/info.svg"
                  alt="" />
                <div class="icon-tooltip">
                  <div
                    class="block-tooltip"
                    [class.show-tooltip]="showTooltipInstant">
                    <div>
                      <div class="header-tooltip">
                        <mat-icon>flash_on</mat-icon>
                        {{
                          'dashboard-payroll-settings.component.debit_cards_instant_transfer'
                            | localise: 'Debit Cards - Instant Transfer'
                        }}
                      </div>
                      <div>
                        {{
                          'dashboard-payroll-settings.component.debit_cards_used_for_instant_transfer'
                            | localise
                              : 'Debit cards are used for instant transfer. Receive your funds in less than 30 minutes for 1.75% fee.'
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            @for (app of astraCards; track app.id) {
              <tr [class.limpid]="!percentBankAccountsMap[app.id]">
                <td>
                  {{ app.firstName + ' ' + app.lastName }} ******
                  {{ app.lastFourDigits }}
                </td>
                <td class="distribution-col-mobile">
                  @if (percentBankAccountsMap[app.id]) {
                    {{
                      percentBankAccountsMap[app.id]
                        | currencyJs: { withoutDecimal: true }
                    }}%
                  } @else {
                    0%
                  }
                </td>
                <td class="capitalize-first-letter">{{ app.accountType }}</td>
                <td>{{ instantFeePercent }}%</td>
                <td>
                  @if (percentBankAccountsMap[app.id]) {
                    {{
                      percentBankAccountsMap[app.id]
                        | currencyJs: { withoutDecimal: true }
                    }}%
                  } @else {
                    0%
                  }
                </td>
                <td class="capitalize-first-letter distribution-col-mobile">
                  {{ app.accountType }}
                </td>
              </tr>
            }
            @for (app of ingoCards; track app.id) {
              <tr [class.limpid]="!percentIngoCardsMap[app.id]">
                <td>
                  {{ app.issuingNetwork }} ******
                  {{ app.last4 }}
                </td>
                <td class="capitalize-first-letter"></td>
                <td>{{ instantFeePercent }}%</td>
                <td>
                  @if (percentIngoCardsMap[app.id]; as percent) {
                    {{ percent | currencyJs: { withoutDecimal: true } }}%
                  } @else {
                    0%
                  }
                </td>
              </tr>
            }
          }
        </table>
      </div>
    } @else {
      <div class="empty_list mobile-debit-cards">
        <img class="icon-svg" src="assets/img/icons/distribution-circle.svg" />
        <div class="header">
          {{
            'dashboard-payroll-settings.component.customize_your_distributions'
              | localise: 'Customize your distributions'
          }}
        </div>
        <div class="content">
          {{
            'dashboard-payroll-settings.component.with_distributions_you_customize_how'
              | localise
                : 'With distributions, you customize how much of your income you want to send to your bank accounts. Simply define the percentage of a deposit to send to each connected account and we will do the rest.'
          }}
        </div>
        <div>
          <button
            class="action-button action-button--primary"
            type="button"
            (click)="editDistributions(editModalTmp)">
            {{
              'dashboard-payroll-settings.component.set_up_my_distributions'
                | localise: 'Set Up My Distributions'
            }}
          </button>
        </div>
      </div>
    }
  </div>

  @if (list?.length) {
    <div class="payroll-block mobile-bank-accounts m-t-24">
      <div>
        @if (partnerList && usingExternalBankAccount) {
          <div class="table-wrapper forms-support-dark-mode">
            <table class="payroll-block__table header-table">
              <tr class="standard_transfer external-accounts">
                <td class="p-l-0 has-tooltip" colspan="4">
                  <img src="/assets/img/icons/user-multiple-group.svg" alt="" />
                  <span>
                    {{
                      'dashboard-payroll-settings.component.external_accounts'
                        | localise: 'External Accounts'
                    }}
                  </span>
                  <img src="/assets/img/icons/info-primery.svg" alt="" />
                </td>
              </tr>
              @for (partner of partnerList; track partner.id) {
                @for (app of partner.brokerBankAccount; track app.id) {
                  <tr [ngClass]="{ limpid: !percentBrokerBankMap[app.id] }">
                    <td class="table-25-per crop-text-mobile">
                      {{ partner.name }}
                    </td>
                    <td class="table-25-per distribution-col-mobile">
                      @if (percentBankAccountsMap[app.id]) {
                        {{
                          percentBrokerBankMap[app.id]
                            | currencyJs: { withoutDecimal: true }
                        }}%
                      }
                      @if (!percentBrokerBankMap[app.id] && app.id > 0) {
                        0%
                      }
                    </td>
                    <td
                      class="table-25-per capitalize-first-letter distribution-col-tbl">
                      {{ app.accountNickname || '-' }}
                    </td>
                    <td class="table-25-per">{{ externalFeePercent }}%</td>
                    <td class="table-25-per distribution-col-tbl">
                      @if (percentBrokerBankMap[app.id]) {
                        {{
                          percentBrokerBankMap[app.id]
                            | currencyJs: { withoutDecimal: true }
                        }}%
                      }
                      @if (!percentBrokerBankMap[app.id] && app.id > 0) {
                        0%
                      }
                    </td>
                    <td
                      class="table-25-per capitalize-first-letter distribution-col-mobile">
                      {{ app.accountNickname || '-' }}
                    </td>
                  </tr>
                }
              }
            </table>
          </div>
        }
        <div class="apply_settings">
          <div class="header-info">
            {{
              'dashboard-wrapper.component.apply_settings'
                | localise: 'Apply settings to all future deposits'
            }}
          </div>
          <div class="content">
            {{
              'dashboard-payroll.component.turning_this_option_on_these_settings'
                | localise
                  : 'By turning this option on, these settings will be automatically applied to all deposits that you receive from your broker. If you do not select this option, you will need to confirm your settings for each deposit before it can be delivered to your account(s).'
            }}
          </div>
          <div class="apply-all">
            <mat-slide-toggle
              [checked]="defaultPayrollSettings"
              (change)="applySettingsAll()"></mat-slide-toggle>
            @if (defaultPayrollSettings) {
              {{
                'dashboard-wrapper.component.your_settings_applied_all_deposits'
                  | localise: 'Your settings are applied to all deposits'
              }}
            } @else {
              {{
                'dashboard-wrapper.component.your_settings_not_applied_all_deposits'
                  | localise: 'Your settings are not applied to all deposits'
              }}
            }
          </div>
        </div>
      </div>
    </div>
  }
</app-dashboard-wrapper>

<ng-template #editModalTmp>
  <div class="edit_settings">
    <div class="header_settings">
      <div class="header-text">
        {{
          'dashboard-payroll-settings.component.edit_distributions'
            | localise: 'Edit Distributions'
        }}
      </div>
      <button
        class="action-button"
        routerLink="/bank-accounts"
        (click)="dialogRef.close()">
        <mat-icon>add</mat-icon>
        <div class="text-btn">
          {{
            'dashboard-payroll-settings.component.add_bank_account'
              | localise: 'Add Account'
          }}
        </div>
      </button>
    </div>
    <div class="payroll-block edit">
      <div class="table-wrapper1 forms-support-dark-mode">
        <table class="payroll-block__table">
          <tr class="header-table">
            <th class="table-25-per">
              {{
                'dashboard-payroll-settings.component.account'
                  | localise: 'Account'
              }}
            </th>
            <th class="table-25-per distribution-col-mobile">
              {{
                'dashboard-payroll-settings.component.distribution'
                  | localise: 'Distribution'
              }}
            </th>
            <th class="table-25-per distribution-col-tbl">
              {{
                'dashboard-payroll-settings.component.type' | localise: 'Type'
              }}
            </th>
            <th class="table-25-per">
              {{
                'dashboard-payroll-settings.component.transaction_fee'
                  | localise: 'Transaction Fee'
              }}
            </th>
            <th class="table-25-per distribution-col-tbl">
              {{
                'dashboard-payroll-settings.component.distribution'
                  | localise: 'Distribution'
              }}
            </th>
            <th class="table-25-per distribution-col-mobile">
              {{
                'dashboard-payroll-settings.component.type' | localise: 'Type'
              }}
            </th>
          </tr>
          <tr class="standard_transfer">
            <td class="p-l-0 has-tooltip" colspan="4">
              <img src="/assets/img/icons/bank.svg" alt="" />
              <span>
                {{
                  'dashboard-payroll-settings.component.bank_accounts_standard_transfer'
                    | localise: 'Bank Accounts - Standard Transfer'
                }}
              </span>
              <img
                (mouseenter)="showTooltipStandard = true"
                (mouseleave)="showTooltipStandard = false"
                (click)="showTooltip()"
                src="/assets/img/icons/info.svg"
                alt="" />
              <div class="icon-tooltip">
                <div
                  class="block-tooltip"
                  [class.show-tooltip]="showTooltipStandard">
                  <div>
                    <div class="header-tooltip">
                      <img
                        class="m-0"
                        src="/assets/img/icons/bank-white.svg"
                        alt="" />
                      <span>
                        {{
                          'dashboard-payroll-settings.component.bank_accounts_standard_transfer'
                            | localise: 'Bank Accounts - Standard Transfer'
                        }}
                      </span>
                    </div>
                    <div>
                      {{
                        'dashboard-payroll-settings.component.accounts_used_standard_transfers'
                          | localise
                            : 'These accounts are used for standard ACH transfers. These transfers are typically posted by the next business day.'
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          @for (app of bankAccounts; track app.id) {
            <tr [ngClass]="{ limpid: !editPercentBankAccountsMap[app.id] }">
              <td>
                {{
                  app.accountNickname ? app.accountNickname : app.institution
                }}
                {{ app.accountNumber }}
              </td>
              <td class="distribution-col-mobile">
                <input
                  [class.err-percent]="totalEqual.value !== 100"
                  [disabled]="changePercent"
                  class="distribution-percent"
                  type="text"
                  mask="0*"
                  suffix="%"
                  placeholder="0%"
                  appDisableAutofill
                  [(ngModel)]="editPercentBankAccountsMap[app.id]"
                  thousandSeparator=","
                  (change)="calcPercent(true)" />
              </td>
              <td class="capitalize-first-letter distribution-col-tbl">
                {{ app.accountType }}
              </td>
              <td>N/A</td>
              <td class="distribution-col-tbl">
                <input
                  [class.err-percent]="totalEqual.value !== 100"
                  [disabled]="changePercent"
                  class="distribution-percent"
                  type="text"
                  mask="0*"
                  suffix="%"
                  placeholder="0%"
                  appDisableAutofill
                  [(ngModel)]="editPercentBankAccountsMap[app.id]"
                  thousandSeparator=","
                  (change)="calcPercent(true)" />
              </td>
              <td class="capitalize-first-letter distribution-col-mobile">
                {{ app.accountType }}
              </td>
            </tr>
          }
          @if (astraCards.length > 0 || ingoCards.length > 0) {
            <tr class="standard_transfer">
              <td class="p-l-0 has-tooltip" colspan="4">
                <img src="/assets/img/icons/flash.svg" alt="" />
                <span
                  >{{
                    'dashboard-payroll-settings.component.debit_cards_instant_transfer'
                      | localise: 'Debit Cards - Instant Transfer'
                  }}
                </span>
                <img
                  (mouseenter)="showTooltipInstant = true"
                  (mouseleave)="showTooltipInstant = false"
                  (click)="showHideTooltipInstant()"
                  src="/assets/img/icons/info.svg"
                  alt="" />
                <div class="icon-tooltip">
                  <div
                    class="block-tooltip"
                    [class.show-tooltip]="showTooltipInstant">
                    <div>
                      <div class="header-tooltip">
                        <mat-icon>flash_on</mat-icon>
                        {{
                          'dashboard-payroll-settings.component.debit_cards_instant_transfer'
                            | localise: 'Debit Cards - Instant Transfer'
                        }}
                      </div>
                      <div>
                        {{
                          'dashboard-payroll-settings.component.debit_cards_used_for_instant_transfer'
                            | localise
                              : 'Debit cards are used for instant transfer. Receive your funds in less than 30 minutes for 1.75% fee.'
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            @for (app of astraCards; track app.id) {
              <tr [ngClass]="{ limpid: !editPercentBankAccountsMap[app.id] }">
                <td>
                  {{ app.firstName + ' ' + app.lastName }} ******
                  {{ app.lastFourDigits }}
                </td>
                <td class="distribution-col-mobile">
                  <input
                    [class.err-percent]="totalEqual.value !== 100"
                    [disabled]="changePercent"
                    class="distribution-percent"
                    type="text"
                    mask="0*"
                    suffix="%"
                    placeholder="0%"
                    appDisableAutofill
                    [(ngModel)]="editPercentBankAccountsMap[app.id]"
                    thousandSeparator=","
                    (change)="calcPercent(true)" />
                </td>
                <td class="capitalize-first-letter distribution-col-tbl">
                  {{ app.accountType }}
                </td>
                <td>{{ instantFeePercent }}%</td>
                <td class="distribution-col-tbl">
                  <input
                    [class.err-percent]="totalEqual.value !== 100"
                    [disabled]="changePercent"
                    class="distribution-percent"
                    type="text"
                    mask="0*"
                    suffix="%"
                    placeholder="0%"
                    appDisableAutofill
                    [(ngModel)]="editPercentBankAccountsMap[app.id]"
                    thousandSeparator=","
                    (change)="calcPercent(true)" />
                </td>
                <td class="capitalize-first-letter distribution-col-mobile">
                  {{ app.accountType }}
                </td>
              </tr>
            }
            @for (app of ingoCards; track app.id) {
              <tr [ngClass]="{ limpid: !editPercentIngoCardsMap[app.id] }">
                <td>
                  {{ app.issuingNetwork }} ******
                  {{ app.last4 }}
                </td>
                <td class="capitalize-first-letter"></td>
                <td>{{ instantFeePercent }}%</td>
                <td>
                  <input
                    [class.err-percent]="totalEqual.value !== 100"
                    [disabled]="changePercent"
                    class="distribution-percent"
                    type="text"
                    mask="0*"
                    suffix="%"
                    placeholder="0%"
                    appDisableAutofill
                    [(ngModel)]="editPercentIngoCardsMap[app.id]"
                    thousandSeparator=","
                    (change)="calcPercent(true)" />
                </td>
              </tr>
            }
          }
        </table>
      </div>
    </div>
    @if (isExternalAccount) {
      <div class="payroll-block edit m-t-32">
        @if (partnerList) {
          <div class="table-wrapper1 forms-support-dark-mode">
            <table class="payroll-block__table">
              <tr class="standard_transfer external-accounts">
                <td colspan="4" class="has-tooltip">
                  <img src="/assets/img/icons/user-multiple-group.svg" alt="" />
                  <span>
                    {{
                      'bank-account-distribution.component.external_accounts'
                        | localise: 'External Accounts'
                    }}
                  </span>
                  <img src="/assets/img/icons/info-primery.svg" alt="" />
                </td>
              </tr>
              @for (partner of partnerList; track partner.id) {
                @for (bank of partner.brokerBankAccount; track bank.id) {
                  <tr
                    class="external-accounts"
                    [ngClass]="{ limpid: !editPercentBrokerBankMap[bank.id] }">
                    <td class="table-25-per">
                      {{ partner.name }}
                    </td>

                    <td class="table-25-per">
                      {{ bank.accountNickname || '-' }}
                    </td>

                    <td class="table-25-per distribution-col-mobile">
                      <input
                        [class.err-percent]="totalEqual.value !== 100"
                        [disabled]="changePercent"
                        class="distribution-percent"
                        type="text"
                        mask="0*"
                        suffix="%"
                        placeholder="0%"
                        appDisableAutofill
                        [(ngModel)]="editPercentBrokerBankMap[bank.id]"
                        thousandSeparator=","
                        (change)="calcPercent(true)" />
                    </td>

                    <td class="table-25-per">{{ externalFeePercent }}%</td>

                    <td class="table-25-per distribution-col-tbl">
                      <input
                        [class.err-percent]="totalEqual.value !== 100"
                        [disabled]="changePercent"
                        class="distribution-percent"
                        type="text"
                        mask="0*"
                        suffix="%"
                        placeholder="0%"
                        appDisableAutofill
                        [(ngModel)]="editPercentBrokerBankMap[bank.id]"
                        thousandSeparator=","
                        (change)="calcPercent(true)" />
                    </td>
                  </tr>
                }
              }
            </table>
          </div>
        }
      </div>
    }
    <div class="block-apply">
      <div class="apply_settings">
        <div class="header-info">
          {{
            'dashboard-wrapper.component.apply_settings'
              | localise: 'Apply settings to all future deposits'
          }}
        </div>
        <div class="content">
          {{
            'dashboard-payroll.component.turning_this_option_on_these_settings'
              | localise
                : 'By turning this option on, these settings will be automatically applied to all deposits that you receive from your broker. If you do not select this option, you will need to confirm your settings for each deposit before it can be delivered to your account(s).'
          }}
        </div>
        <div class="apply-all">
          <mat-slide-toggle
            [disabled]="!equalPercent"
            [checked]="defaultPayrollSettings"
            (change)="
              defaultPayrollSettings = !defaultPayrollSettings;
              changeData = true;
              this.wasActive = false
            "></mat-slide-toggle>
          @if (defaultPayrollSettings) {
            {{
              'dashboard-wrapper.component.your_settings_applied_all_deposits'
                | localise: 'Your settings are applied to all deposits'
            }}
          } @else {
            {{
              'dashboard-wrapper.component.your_settings_not_applied_all_deposits'
                | localise: 'Your settings are not applied to all deposits'
            }}
          }
        </div>
      </div>
      @if (changeData) {
        <div
          class="success"
          [class.err-percent]="!equalPercent"
          [class.equal-percent]="equalPercent">
          @if (!equalPercent) {
            <b>
              <div class="not-equals">
                <div class="icon-size">
                  <mat-icon>priority_high</mat-icon>
                </div>
                <div class="m-0-16">
                  {{
                    'bank-account-distribution.component.account_distributions_need'
                      | localise
                        : 'Your account distributions need to equal 100% before confirming'
                  }}
                </div>
                <div class="total-equal">
                  {{ totalEqual | currencyJs: { withoutDecimal: true } }}%
                </div>
              </div>
            </b>
          } @else {
            <b>
              <div class="equal">
                <div class="icon-size">
                  <mat-icon>done</mat-icon>
                </div>
                <div class="m-0-16">
                  {{
                    'confirm-deposit-distributions.componen.distributions_equal'
                      | localise: 'Your distributions are equal to'
                  }}
                </div>
                <div class="total-equal">
                  {{ totalEqual | currencyJs: { withoutDecimal: true } }}%
                </div>
              </div>
            </b>
          }
        </div>
      }
    </div>
    <div class="confirm_btns">
      <button
        class="action-button"
        mat-dialog-close
        (click)="getPayrollSettings()">
        {{
          'dashboard-payroll-settings.component.cancel_button'
            | localise: 'Cancel'
        }}
      </button>
      <button
        class="confirm"
        [disabled]="!changeData || !equalPercent || changePercent"
        (click)="save()">
        {{
          'dashboard-payroll-settings.component.save_changes'
            | localise: 'Save Changes'
        }}
      </button>
    </div>
  </div>
</ng-template>
